import Vue from 'vue'
import App from './App.vue'
import router from './router';
import store from './store';

// Bootstrap vue
import BootstrapVue from 'bootstrap-vue'
Vue.use(BootstrapVue);

// Use Vue cookie to store Bearer
var VueCookie = require('vue-cookie');
Vue.use(VueCookie);

// Datepicker
import DatePicker from 'vue2-datepicker'
Vue.use(DatePicker);

// Vue Moment.js
import VueMoment from 'vue-moment'
Vue.use(VueMoment);

// API
import * as api from './api.js'

// Axios
const axios = require('axios');
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
axios.defaults.headers.common['Accept'] = 'application/json';

let adamApiPlugin = {
  install(Vue, options) {
    window.adamApi = axios.create({
      baseURL: api.apiDomain,
      timeout: 120000
    });
    window.api = api;
  }
}
Vue.use(adamApiPlugin);

new Vue({
  render: h => h(App),
  router,
  store
}).$mount('#app');
